import { useGetSSRCategories } from "../../../../api/products/useSSRApi";
import styles from "./SSRCategoriesTable.module.css";

const SSRCategoriesTable = () => {
  const { data: categories = [], loading, error, refetch } = useGetSSRCategories();

  return (
    <div className={styles.container}>
      {/* Info Banner */}
      <div className={styles.infoBanner}>
        <div className={styles.infoIcon}>ℹ️</div>
        <div className={styles.infoContent}>
          <strong>System-Defined Categories</strong>
          <p>
            SSR Categories are fixed master data and cannot be modified. These
            categories are used to organize SSR items across the system.
          </p>
        </div>
      </div>

      {/* Error Banner */}
      {error && (
        <div className={styles.infoBanner} style={{ background: "#fef2f2", borderColor: "#fecaca" }}>
          <div className={styles.infoIcon}>⚠️</div>
          <div className={styles.infoContent}>
            {error}
            <button className={styles.retryBtn} onClick={() => refetch()}>
              Retry
            </button>
          </div>
        </div>
      )}

      {loading && (
        <div className={styles.loadingState}>
          <p>Loading categories…</p>
        </div>
      )}

      {/* Categories Grid */}
      {!loading && (
      <div className={styles.categoriesGrid}>
        {categories.map((category) => (
          <div key={category.id} className={styles.categoryCard}>
            <div
              className={styles.categoryIcon}
              style={{ background: category.color }}
            >
              {category.icon}
            </div>
            <div className={styles.categoryInfo}>
              <div className={styles.categoryHeader}>
                <h4>{category.name}</h4>
                <span className={styles.categoryCode}>{category.code}</span>
              </div>
              <p className={styles.categoryDesc}>{category.description}</p>
            </div>
          </div>
        ))}
      </div>
      )}

      {/* Statistics */}
      <div className={styles.stats}>
        <div className={styles.statItem}>
          <div className={styles.statValue}>{categories.length}</div>
          <div className={styles.statLabel}>Total Categories</div>
        </div>
        <div className={styles.statItem}>
          <div className={styles.statValue}>Read-Only</div>
          <div className={styles.statLabel}>Access Level</div>
        </div>
        <div className={styles.statItem}>
          <div className={styles.statValue}>System</div>
          <div className={styles.statLabel}>Managed By</div>
        </div>
      </div>
    </div>
  );
};

export default SSRCategoriesTable;